'use client';

import React from 'react';
import { cn } from '@/lib/cn';

export interface StepperCellProps extends React.HTMLAttributes<HTMLDivElement> {
  active?: boolean;
  completed?: boolean;
}

export function StepperCell({ active, completed, className, ...rest }: StepperCellProps) {
  const isActiveOrCompleted = Boolean(active || completed);

  return (
    <div
      className={cn(
        'flex-1 h-1 rounded-full',
        isActiveOrCompleted ? 'bg-accent' : 'bg-tertiary',
        className,
      )}
      {...rest}
    />
  );
}

export interface StepperMobileProps extends React.HTMLAttributes<HTMLDivElement> {
  totalSteps: number;
  currentStepId: number;
}

export default function StepperMobile({
  totalSteps,
  currentStepId,
  className,
  ...rest
}: StepperMobileProps) {
  const stepsArray = React.useMemo(
    () => Array.from({ length: totalSteps }, (_, index) => index + 1),
    [totalSteps],
  );

  return (
    <div className={cn('flex items-center gap-2', className)} {...rest}>
      {stepsArray.map(stepId => (
        <StepperCell
          key={stepId}
          active={stepId === currentStepId}
          completed={stepId < currentStepId}
        />
      ))}
    </div>
  );
}
